// extracted by mini-css-extract-plugin
export default {"root":"styles_root__ztOW8","button":"styles_button__mwwjp","content-row":"styles_content-row__-qcLK","separator":"styles_separator__yNBsD"};